import { GooglePayMerchantInfo } from '../../../../types/StoreState';

const isTestEnv = process.env.NODE_ENV === 'development';

export const getMerchantInfo = ({ domain, authJwt, ...rest }: GooglePayMerchantInfo) => {
  // omit domain && authJwt in test env because flow is failing
  if (isTestEnv) {
    return rest;
  }

  return {
    domain,
    authJwt,
    ...rest,
  };
};
